// Shared Lenis instance holder so route changes can reset scroll through Lenis
// (window.scrollTo is unreliable while Lenis owns the scroll position).
let current = null;
export const setLenis = (l) => { current = l; };
export const getLenis = () => current;
